import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import MenuItem from '../Menu/MenuItem';
import AppPromo from '../Menu/AppPromo';
const SubMenu = (props) => {
    const { os, platform, subMenu, authFunctions } = props;
    const { links } = subMenu;
    const type = links && Object.values(links).some(link => link.type === 'nested')
        ? 'nested'
        : 'leaf';
    return (_jsx(React.Fragment, { children: links &&
            Object.keys(links).map((link, index) => {
                const lastItem = index === Object.keys(links).length - 1;
                const showMobileAppBanner = link === 'mobile-app';
                const hideAppPromo = link === 'app-promo';
                return (_jsxs("div", { className: clsx(type === 'leaf' && 'iv-block iv-w-[155px]', type !== 'leaf' &&
                        !hideAppPromo &&
                        'xl:iv-inline-block lg:iv-inline-block iv-align-top', type !== 'leaf' &&
                        !showMobileAppBanner &&
                        'md:iv-mb-30 iv-mr-50 iv-w-[170px]', hideAppPromo && 'iv-hidden'), children: [_jsx(MenuItem, { lastItem: lastItem, os: os, platform: platform, menuItem: links[link], authFunctions: authFunctions }), showMobileAppBanner && _jsx(AppPromo, { os: os, platform: platform })] }, index));
            }) }));
};
export default SubMenu;
